const translations = {
    unsavedChangesConfirm: 'Leave and discard',
    unsavedChangesDecline: 'Keep editing',
    unsavedChangesMessage: 'You have unsaved changes. If you leave now, those changes are lost.',
    unsavedChangesTitle: 'Discard unsaved changes?'
};

export default translations;
